"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var styles_1 = require("@mui/material/styles");
var sub_1 = __importDefault(require("date-fns/sub"));
var calculateKeyInsights_1 = require("utils/calculateKeyInsights");
var processExpenditures_1 = require("utils/processExpenditures");
var KeyInsightsItem_1 = __importDefault(require("./KeyInsightsItem"));
var PREFIX = 'KeyInsightsOverview';
var classes = {
    descriptionHeadingContainer: "".concat(PREFIX, "-descriptionHeadingContainer"),
    descriptionHeading: "".concat(PREFIX, "-descriptionHeading"),
    topFeaturesContainer: "".concat(PREFIX, "-topFeaturesContainer"),
    serviceStatAttributeLabel: "".concat(PREFIX, "-serviceStatAttributeLabel"),
    serviceStatAttributeContainer: "".concat(PREFIX, "-serviceStatAttributeContainer"),
    rightAttributeContainer: "".concat(PREFIX, "-rightAttributeContainer"),
    heading: "".concat(PREFIX, "-heading"),
};
// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.descriptionHeadingContainer)] = {
            color: 'hsl(0,0%,30%)',
            fontWeight: 500,
        },
        _b[".".concat(classes.descriptionHeading)] = {
            color: theme.palette.primary.main,
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        _b[".".concat(classes.topFeaturesContainer)] = {
            marginLeft: theme.spacing(3),
            height: theme.spacing(3),
        },
        _b[".".concat(classes.serviceStatAttributeLabel)] = {
            width: 100,
            color: theme.palette.grey[600],
        },
        _b[".".concat(classes.serviceStatAttributeContainer)] = {
            display: 'flex',
            fontSize: '1rem',
            color: theme.palette.text.primary,
            fontWeight: 500,
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        _b[".".concat(classes.rightAttributeContainer)] = {
            marginLeft: 'auto',
            marginRight: theme.spacing(2.5),
        },
        _b[".".concat(classes.heading)] = {
            fontSize: 20,
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
            letterSpacing: '0.023em',
        },
        _b);
});
var KeyInsightsOverview = function (_a) {
    var serviceStatWithService = _a.serviceStatWithService;
    var today = new Date();
    var lastMonthDate = (0, sub_1.default)(today, { months: 1 });
    var newAndCancelledTools = (0, calculateKeyInsights_1.calculateNewAndCancelledTools)(serviceStatWithService, (0, end2end_1.getMonthName)(lastMonthDate));
    var secLastMonthDate = (0, sub_1.default)(today, { months: 2 });
    var lastMonthSpent = (0, processExpenditures_1.calculateMonthSpent)(serviceStatWithService, lastMonthDate);
    var prevMonthSpent = (0, processExpenditures_1.calculateMonthSpent)(serviceStatWithService, secLastMonthDate);
    var monthDifference = (Math.abs(prevMonthSpent - lastMonthSpent) / prevMonthSpent);
    var spendTMTData = {
        templateName: 'MtMDifference',
        lastAvailableMonth: (0, end2end_1.getMonthName)(lastMonthDate),
        lastMonthSpent: lastMonthSpent,
        secondLastAvailableMonth: (0, end2end_1.getMonthName)(secLastMonthDate),
        secondLastMonthSpent: prevMonthSpent,
        keyword: (lastMonthSpent - prevMonthSpent) >= 0 ? 'up' : 'down',
        percentage: monthDifference,
    };
    var renewalsAnnual = (0, calculateKeyInsights_1.getRenewalsSummary)(serviceStatWithService);
    var keyInsights = [spendTMTData, renewalsAnnual, newAndCancelledTools];
    return ((0, jsx_runtime_1.jsxs)(Root, { children: [(0, jsx_runtime_1.jsx)("h2", __assign({ className: classes.heading }, { children: "Key insights" })), keyInsights === null || keyInsights === void 0 ? void 0 : keyInsights.map(function (keyInsight, idx) { return (0, jsx_runtime_1.jsx)(KeyInsightsItem_1.default, { order: idx + 1, data: keyInsight }, keyInsight.templateName); })] }));
};
exports.default = KeyInsightsOverview;
